export enum FormOfSettlementWithTaxOffice {
    RevenueAndExpenseLedger = 'RevenueAndExpenseLedger',
    FlatRateTax = 'FlatRateTax',
    LumpSum = 'LumpSum'
}
